// 步骤页面白名单
export const StepActiveRoutes = {
  STEP_1_ACCOUNT_REVIEW: [''],
  STEP_2_ADD_PAYMENT: ['payment'],
  STEP_3_CREATE_AD: ['ad-campaign-create', 'ad-group-create', 'ad-creation'],
  TO_FIX_REVIEW_DIS_APPROVED: ['account_complete'],
};

const btnWhiteList = Object.values(StepActiveRoutes).reduce((total, item) => [...total, ...item], []);

// 显示新手任务: 步骤白名单 + 页面白名单
export const NewTaskWhiteRouteList = [
  ...btnWhiteList,
  'dashboardIndex',
  'perf-campaign',
  'perf-adgroup',
  'perf-creative',
  'library-image',
  'library-video',
  'library-playable',
  'library-native',
  'qualification_industrial',
  'transaction',
  'tan_block',
  'payment_promotion',
];

export const canShowBestPracticeRoutes = ['ad-campaign-create'];

export const CreationBestPracticeQaMap = {
  OBJECTIVE: 'objective',
  PIXEL: 'Pixel',
  TARGETING: 'Targeting',
  BUDGET: 'Budget+Learning Phase',
  BID: 'Bid',
  FORMAT: 'Format',
};
